import { render, staticRenderFns } from "./SyncEmail.vue?vue&type=template&id=2d9f1926&scoped=true&"
import script from "./SyncEmail.vue?vue&type=script&lang=js&"
export * from "./SyncEmail.vue?vue&type=script&lang=js&"
import style0 from "./SyncEmail.vue?vue&type=style&index=0&id=2d9f1926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9f1926",
  null
  
)

export default component.exports